module.exports = __webpack_public_path__ + "media/THE_4_mobile.1de01f6b.mp4";